import { Component, DestroyRef, inject, output, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalComponent } from '../../../shared/components/modal/modal';
import { RollupService } from '../../../core/services/rollup.service';
import { ToastService } from '../../../core/services/toast.service';
import { apiErrorMessage } from '../../../shared/utils/api-error';

@Component({
  selector: 'app-create-rollup-taxonomy-modal',
  imports: [ModalComponent, NgClass],
  templateUrl: './create-rollup-taxonomy-modal.html',
})
export class CreateRollupTaxonomyModalComponent {
  closed = output<void>();

  private rollupService = inject(RollupService);
  private toastService = inject(ToastService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  protected name = signal('');
  protected definition = signal('');
  protected type = signal<'situation' | 'response'>('situation');
  protected showErrors = signal(false);
  protected submitting = signal(false);

  protected onSubmit(): void {
    this.showErrors.set(true);
    if (!this.name().trim() || !this.definition().trim()) return;

    this.submitting.set(true);
    const payload = { name: this.name().trim(), definition: this.definition().trim() };
    const request$ =
      this.type() === 'situation'
        ? this.rollupService.createRollupSituationCategory(payload)
        : this.rollupService.createRollupResponseCategory(payload);

    request$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (created) => {
        this.toastService.show('Rollup taxonomy created successfully');
        this.router.navigate(['/configuration/rollup', this.type(), created.id]);
      },
      error: (err) => {
        this.toastService.show(apiErrorMessage(err, 'Failed to create rollup taxonomy'), 'error');
        this.submitting.set(false);
      },
    });
  }
}
